export default [
    {
        type: "selection",
        width: 38,
        align: "center",
    },
    {
        title: 'Available Roles',
        key: 'RoleName',
        minWidth: 80,
    },

]
